import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { ErrorScreen } from './ErrorScreen'

interface LucianErrorScreenProps {
  error: Error
}

const ErrorBoundaryInner: React.FC<LucianErrorScreenProps> = props => {
  // Report error to APM
  useEffect(() => {
    console.error(props.error)
  }, [])

  return (
    <>
      <Helmet>
        <title>Error</title>
      </Helmet>
      <ErrorScreen />
    </>
  )
}

export default ErrorBoundaryInner
